<template lang="pug">
section
  s-page-title(
    :previous='true'
    :subtitle='object.object_name'
    :title='sectionId ? "Редактирование подъезда" : "Добавление подъезда"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12 sm2)
          v-text-field(
            :error='errors.has("section_number")'
            :error-messages='errors.first("section_number")'
            v-model='item.section_number'
            label='Номер подъезда'
            mask='##'
          )

        v-flex(xs12 sm6)
          v-text-field(
            :error='errors.has("section_name")'
            :error-messages='errors.first("section_name")'
            v-model='item.section_name'
            label='Название подъезда'
          )
        v-flex(xs12 sm4)
          v-checkbox(
            v-model='item.hidden'
            label='Скрыть'
            color='primary'
          )
        v-flex(xs12 sm3)
          v-text-field(
          :error='errors.has("min_floor")'
          :error-messages='errors.first("min_floor")'
          v-model='item.min_floor'
          label='Мин. этаж'
          mask='##'
          )
        v-flex(xs12 sm3)
          v-text-field(
          :error='errors.has("max_floor")'
          :error-messages='errors.first("max_floor")'
          v-model='item.max_floor'
          label='Макс. этаж'
          mask='##'
          )
        v-flex(xs12 sm4)
          v-text-field(
            :error='errors.has("additional_floors")'
            :error-messages='errors.first("additional_floors")'
            v-model='item.additional_floors'
            label='Доп.этажи (через запятую)'
            )
        v-flex(xs12 sm2)
          v-text-field(
          :error='errors.has("compas_rotate_degree")'
          :error-messages='errors.first("compas_rotate_degree")'
          v-model='item.compas_rotate_degree'
          label='Угол поворота компаса'
          mask='###'
          )
        v-flex(xs12 sm4)
          s-date-picker(
            :validator='errors'
            v-model='item.date_keys'
            label='Дата сдачи подъезда'
            name='date_keys'
          )
        v-flex(xs12 sm8)
          v-slider(
            v-model='item.progress'
            :error='errors.has("progress")'
            :error-messages='errors.first("progress")'
            label="Процент завершения"
            persistent-hint
            step="1"
            thumb-label="always"
          )
        v-flex(xs12 sm3)
          v-text-field(
            v-model='item.views.top'
            label='Вид из окна сверху'
          )
        v-flex(xs12 sm3)
          v-text-field(
            v-model='item.views.right'
            label='Вид из окна справа'
          )
        v-flex(xs12 sm3)
          v-text-field(
            v-model='item.views.bottom'
            label='Вид из окна снизу'
          )
        v-flex(xs12 sm3)
          v-text-field(
            v-model='item.views.left'
            label='Вид из окна слева'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("path_scheme")'
            :error-messages='errors.first("path_scheme")'
            v-model='item.path_scheme'
            label='PATH на схеме генплана'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("path_genplan")'
            :error-messages='errors.first("path_genplan")'
            v-model='item.path_genplan'
            label='Путь обводки на генплане'
            disabled=true
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("mark_genplan")'
            :error-messages='errors.first("mark_genplan")'
            v-model='item.mark_genplan'
            label='Метка подъезда на генплане'
            disabled=true
          )
        v-flex(xs12)
          s-image-upload(
            :src='item.avatar_url'
            @remove='onRemoveAvatar'
            v-model='avatar'
            label='Внешний вид подъезда'

          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='onSave'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { createFormData } from '@/utils'

export default {
  name: 'Edit',

  props: ['id', 'objectId', 'sectionId'],

  data: () => ({
    item: {
      min_floor: 0,
      max_floor: 0,
      views: {
        top: null,
        right: null,
        bottom: null,
        left: null
      }
    },
    avatar: null
  }),

  async mounted() {
    if (this.sectionId) {
      try {
        let responseData = (
          await this.fetchSingle({
            id: this.sectionId
          })
        ).data

        if (!responseData.views)
          responseData.views = {
            top: null,
            right: null,
            bottom: null,
            left: null
          }
        this.item = responseData
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки подъезда')
      }
    }
  },

  methods: {
    async onSave() {
      this.item.object_id = this.objectId
      let data = createFormData(this.item)

      try {
        if (this.sectionId) {
          await this.update({
            id: this.sectionId,
            data
          })
        } else {
          await this.create({ data })
        }

        this.$root.showSnack('Подъезд сохранен')
        this.$router.push({
          name: 'Complexes.Objects.Sections',
          params: {
            id: this.id,
            objectId: this.objectId
          }
        })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    onRemoveAvatar() {
      this.item.avatar = null
    },

    createFormData___() {
      let data = new FormData()
      this.item.object_id = this.objectId

      Object.keys(this.item).forEach(key => {
        data.append(key, this.item[key])
      })

      return data
    },

    ...mapActions('objects/sections', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    object() {
      return this.objectById(this.objectId)
    },

    ...mapGetters('objects/sections', ['isLoading', 'objectById'])
  }
}
</script>
